export type Mask = {
  searchValue: RegExp;
  replaceValue: string;
};

export const MASKS: { [key: string]: Mask } = {
  phone: {
    searchValue: /(\d{2})(\d{4})(\d{0,4})/,
    replaceValue: "($1) $2-$3",
  },
  celphone: {
    searchValue: /(\d{2})(\d{5})(\d{0,4})/,
    replaceValue: "($1) $2-$3",
  },
  cpf: {
    searchValue: /(\d{3})(\d{3})(\d{3})(\d{2})/,
    replaceValue: "$1.$2.$3-$4",
  },
  cep: {
    searchValue: /(\d{5})(\d{3})/,
    replaceValue: "$1-$2",
  },
  time: {
    searchValue: /(\d{2})(\d{2})/,
    replaceValue: "$1:$2",
  },
  currency: {
    searchValue: /(\d+)(\d{2})/,
    replaceValue: "R$ $1,$2", // Esta máscara não será usada diretamente
  },
};

export const handleMask = (event: any): string => {
  const type = event.target.attributes["mask"]?.value;
  const value = event.target.value;

  if (!type) return value;

  // Detecta se o usuário está apagando
  if (event.inputType === "deleteContentBackward") {
    return value;
  }

  let mask: Mask;
  let numericValue;
  let maxDigits;
  let limitedValue;

  switch (type) {
    // case "time":
    //   mask = MASKS["time"];
    //   // Remove qualquer caractere que não seja número
    //   numericValue = value.replace(/\D/g, "");

    //   // Limita ao tamanho máximo permitido (11 dígitos)
    //   maxDigits = 4;
    //   limitedValue = numericValue.substring(0, maxDigits);

    //   return limitedValue.replace(mask.searchValue, mask.replaceValue).trim();
    case "cep":
      mask = MASKS["cep"];

      // Remove qualquer caractere que não seja número
      numericValue = value.replace(/\D/g, "");

      // Limita ao tamanho máximo permitido (11 dígitos)
      maxDigits = 8;
      limitedValue = numericValue.substring(0, maxDigits);

      return limitedValue.replace(mask.searchValue, mask.replaceValue).trim();
    case "phone":
      mask = MASKS["celphone"];

      // Remove qualquer caractere que não seja número
      numericValue = value.replace(/\D/g, "");

      // Limita ao tamanho máximo permitido (11 dígitos)
      maxDigits = 11;
      limitedValue = numericValue.substring(0, maxDigits);

      // Aplica a máscara com base no tamanho
      if (limitedValue.length <= 10) {
        mask = MASKS["phone"];
      }
      return limitedValue.replace(mask.searchValue, mask.replaceValue).trim();
    case "cpf":
      mask = MASKS["cpf"];
      const numericValueCPF = value.replace(/\D/g, "");
      // Remove caracteres excedentes (CPF só tem 11 dígitos)
      const limitedValueCPF = numericValueCPF.substring(0, 11);
      // Aplica a máscara enquanto digita
      return limitedValueCPF
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4")
        .trim();

    case "currency": {
      // Remove todos os caracteres não numéricos
      let numericValue = value.replace(/\D/g, "");

      // Limita o número de dígitos (15 permite até 999.999.999.999,99)
      const maxDigits = 15;
      numericValue = numericValue.substring(0, maxDigits);

      if (!numericValue) return "";

      // Adiciona zeros à esquerda para garantir pelo menos 3 dígitos
      numericValue = numericValue.padStart(3, "0");

      // Divide em parte inteira e decimal
      const integerPart = numericValue.slice(0, -2).replace(/^0+/, "") || "0";
      const decimalPart = numericValue.slice(-2);

      // Formata a parte inteira com separadores de milhar
      const formattedInteger =
        integerPart
          .split("")
          .reverse()
          .join("")
          .match(/.{1,3}/g)
          ?.join(".")
          .split("")
          .reverse()
          .join("") || "0";

      return `R$ ${formattedInteger},${decimalPart}`;
    }

    default:
      const maxLength = type.length;
      const digitsOnly = value.replace(/\D/g, '');
      return digitsOnly.slice(0, maxLength);
  }
};
